import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { Pricing } from './pricing';
import { App } from './App';
import reportWebVitals from './reportWebVitals';

const allPricesID: string = 'build-a-pump-all-prices';
const usPricesID: string = 'build-a-pump-us-prices';
const caPricesID: string = 'build-a-pump-ca-prices';
const noPricesID: string = 'build-a-pump';
let priceScheme: Pricing = Pricing.NONE;
let root: any;

const setPricingScheme = () => {
  if (document.getElementById(allPricesID)) {
    priceScheme = Pricing.ALL;
    root = ReactDOM.createRoot(
      document.getElementById(allPricesID) as HTMLElement
    );
    return;
  }

  if (document.getElementById(usPricesID)) {
    priceScheme = Pricing.US;
    root = ReactDOM.createRoot(
      document.getElementById(usPricesID) as HTMLElement
    );
    return;
  }
  
  if (document.getElementById(caPricesID)) {
    priceScheme = Pricing.CA;
    root = ReactDOM.createRoot(
      document.getElementById(caPricesID) as HTMLElement
    );
    return;
  }

  if (document.getElementById(noPricesID)) {
    priceScheme = Pricing.NONE;
    root = ReactDOM.createRoot(
      document.getElementById(noPricesID) as HTMLElement
    );
    return;
  }
};

setPricingScheme();

root.render(
  <App showPricing={priceScheme} />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
